<form
  id="support-request-form"
  class="flex min-w-0 flex-col"
  [formGroup]="form"
  (ngSubmit)="submit()"
>
  <h2 mat-dialog-title class="flex items-start gap-3">
    <span
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-700"
    >
      <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
    </span>
    <span class="min-w-0">
      <span class="block text-xl font-semibold">Contact support</span>
      <span class="text-secondary mt-1 block text-sm font-normal">
        Tell us what you need help with and our team will follow up.
      </span>
    </span>
  </h2>

  <mat-dialog-content class="space-y-4">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Your email</mat-label>
      <input
        matInput
        formControlName="email"
        type="email"
        autocomplete="email"
        readonly
      />
      @if (form.controls.email.invalid) {
        <mat-error>Your account email is unavailable.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Your message</mat-label>
      <textarea
        matInput
        formControlName="comments"
        cdkTextareaAutosize
        cdkAutosizeMinRows="5"
        cdkAutosizeMaxRows="10"
        aria-describedby="support-message-hint"
      ></textarea>
      <mat-hint id="support-message-hint">
        Include any details that will help us investigate.
      </mat-hint>
      @if (commentsControl.touched && commentsControl.hasError("required")) {
        <mat-error>Please enter a message.</mat-error>
      } @else if (
        commentsControl.touched && commentsControl.hasError("trimmedMinLength")
      ) {
        <mat-error>
          Enter at least {{ minimumMessageLength }} characters.
        </mat-error>
      }
    </mat-form-field>

    <div class="rounded-lg border p-4">
      <input
        #fileInput
        class="hidden"
        type="file"
        [attr.accept]="acceptedFileTypes"
        (change)="onFileSelected($event)"
      />

      @if (!selectedFile) {
        <button
          mat-stroked-button
          type="button"
          [disabled]="isSubmitting"
          (click)="fileInput.click()"
        >
          <mat-icon [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
          Add attachment
        </button>
        <p class="text-secondary mt-2 text-xs">
          Optional. One document, image, or archive up to 10 MB.
        </p>
      } @else {
        <div class="flex min-w-0 items-center gap-3">
          <mat-icon
            class="shrink-0"
            [svgIcon]="'heroicons_outline:document'"
          ></mat-icon>
          <span class="min-w-0 flex-1 truncate text-sm">
            {{ selectedFile.name }}
          </span>
          <button
            mat-icon-button
            type="button"
            aria-label="Remove attachment"
            [disabled]="isSubmitting"
            (click)="removeAttachment()"
          >
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>
      }

      @if (attachmentError) {
        <p class="mt-2 text-sm text-red-600" role="alert" aria-live="polite">
          {{ attachmentError }}
        </p>
      }
    </div>

    @if (submitError) {
      <div
        class="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700"
        role="alert"
        aria-live="assertive"
      >
        {{ submitError }}
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      [disabled]="isSubmitting"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid || !!attachmentError || isSubmitting"
    >
      @if (isSubmitting) {
        <mat-progress-spinner
          class="mr-2 inline-block"
          diameter="18"
          mode="indeterminate"
        ></mat-progress-spinner>
        Sending...
      } @else {
        Send request
      }
    </button>
  </mat-dialog-actions>
</form>
